import {
  ChakraProvider as ChakraProviderDefault,
} from '@chakra-ui/react';
import type { ChakraProviderProps, ColorMode } from '@chakra-ui/react';
import React from 'react';

import theme from 'theme/theme';

// Force light mode - bypass any stored dark mode preference
const lightModeManager = {
  type: 'localStorage' as const,
  get: (): ColorMode => 'light',
  set: () => {},
};

interface Props extends ChakraProviderProps {
  cookies?: string;
}

export function ChakraProvider({ children }: Props) {
  return (
    <ChakraProviderDefault colorModeManager={ lightModeManager } theme={ theme }>
      { children }
    </ChakraProviderDefault>
  );
}
